import React, { useEffect } from 'react';
import { Dispatch, bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../reducers';
import * as actions from '../../actions/generalActions';
import { Switch, Route } from 'react-router-dom';
import "./Transport.scss";
import { withRouter } from 'react-router';
import TransportListPage from './TransportListPage';
import TransportDetail from './TransportDetail';
import TransportForm from './TransportForm';
import TransportWithoutForm from './TransportWithoutForm';
import Archive from "../Archive/Archive";

import Page404 from "../Page404";

interface Props {
    intl: any;
    actions: any;
    history: any;
}

const Transport = (props: Props) => {
    useEffect(() => {
        props.actions.getUserPermissionsAndResponsibilities();
    }, []);

    return (
        <div className="transport inside-container">
            <Switch>
                <Route exact path="/dashboard/transport" component={TransportListPage} />
                <Route exact path="/dashboard/transport/create" component={TransportForm} />
                <Route exact path="/dashboard/transport/create-without" component={TransportWithoutForm} />
                <Route path="/dashboard/transport/archive/:moduleName?" component={Archive} />
                <Route exact path="/dashboard/transport/:transportId" component={TransportDetail} />
                <Route render={() => <Page404 />} />
            </Switch>
        </div>
    );
};

function mapStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        ...state.app,
    };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        actions: bindActionCreators(actions as any, dispatch),
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Transport as any)));
